export const PPC_BUDGET = {
    MIN_DAILY: 5,
    MAX_DAILY: 33333,
    MAX_MONTHLY: 999990,
  };